var getEndpoint = function (path, queryParams) {
    return "/apps/shopify/".concat(path, "?").concat(queryParams);
};
export default getEndpoint;
